import {TOGGLE_DEV_MODE} from './available'

export default {
  [TOGGLE_DEV_MODE](state) {
    state.devMode = !state.devMode
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/dev.js